import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Switch from 'react-switch'

import usePersistedState from '../../hooks/usePersistedState'

import Header from '../../components/Header'
import Button from '../../components/Button'
import Dots from './components/Dots'

import welcomeEnd from '../../assets/welcome-end.svg'
import welcomeWallet from '../../assets/welcome-wallet.svg'
import welcomeHandPork from '../../assets/welcome-hand-pork.svg'
import { Carousel, CarouselBox, BtnVoltar } from './styles'
import Container from '../../components/Container'

const BemVindo: React.FC = () => {
  const [acceptTerms, setAcceptTerms] = usePersistedState('acceptTerms', false)

  const history = useHistory()
  const [quantity] = useState(3)
  const [active, setActive] = useState(0)

  const handleSetProximo = useCallback(() => {
    const newActive = active + 1
    if (newActive < quantity) {
      setActive(newActive)
    }
  }, [active, quantity])

  const handleSetAnterior = useCallback(() => {
    const newActive = active - 1
    if (newActive >= 0) {
      setActive(newActive)
    }
  }, [active])

  const toggleAcceptTerms = useCallback(() => {
    setAcceptTerms(!acceptTerms)
  }, [acceptTerms, setAcceptTerms])

  const handleStart = useCallback(async () => {
    if (acceptTerms) {
      history.push('/contribution')
    } else {
      console.warn('is necessary accept the terms to continue.')
    }
  }, [acceptTerms, history])

  // useEffect(() => {
  //   localStorage.removeItem('@AspADSFamiliaV2:acceptTerms')
  //   localStorage.removeItem('@AspADSFamiliaV2:authorizeTitularPayment')
  //   // localStorage.removeItem('@AspADSFamiliaV2:configData')
  //   localStorage.removeItem('@AspADSFamiliaV2:goalsSelected')
  //   localStorage.removeItem('@AspADSFamiliaV2:PercentualValuePercent')
  //   localStorage.removeItem('@AspADSFamiliaV2:receiveTypeSelected')
  //   localStorage.removeItem('@AspADSFamiliaV2:TimeValueYears')
  //   localStorage.removeItem('@AspADSFamiliaV2:totalRentability')
  //   localStorage.removeItem('@AspADSFamiliaV2:userData')
  //   localStorage.removeItem('@AspADSFamiliaV2:userDetails')
  // }, [])

  return (
    <>
      <Header />
      <Container>
        <Carousel>
          <CarouselBox isActive={active === 0}>
            <img src={welcomeWallet} alt="Carteira" />
            <strong>Quer ter uma aposentadoria de verdade?</strong>
            <p>
              Descubra aqui como você pode ficar financeiramente bem no futuro!
            </p>
            <small>
              Fique tranquilo. Todos os seus dados são privados e estão
              protegidos por nossa{' '}
              <a
                href="https://aspprev.com.br/"
                target="_blank"
                rel="noopener noreferrer"
              >
                política de privacidade
              </a>
              .
            </small>
          </CarouselBox>

          <CarouselBox isActive={active === 1}>
            <img src={welcomeHandPork} alt="Carteira" />
            <strong>
              Investir em previdência privada te proporciona dedução de até 12%
              da base de cálculo do seu Imposto de Renda anual.
            </strong>
          </CarouselBox>

          <CarouselBox isActive={active === 2}>
            <img src={welcomeEnd} alt="Carteira" />
            <strong>Aqui tudo é simples e direto!</strong>
            <p>
              Surgiu algo inesperado? <br />
              Te damos a opção de fazer resgates parciais a partir do 3º ano.
            </p>
            <div>
              <small>
                Ao continuar navegando no site, você concorda com as condições
                de{' '}
                <a
                  href="https://aspprev.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacidade
                </a>{' '}
                e{' '}
                <a
                  href="https://aspprev.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Termos de uso
                </a>{' '}
                do site Aspprev.
              </small>
              <Switch
                onChange={toggleAcceptTerms}
                checked={acceptTerms}
                checkedIcon={false}
                uncheckedIcon={false}
                height={22}
                width={44}
                handleDiameter={18}
                offColor="#DEE3E1"
                offHandleColor="#fff"
                onHandleColor="#fff"
                onColor="#31D19E"
              />
            </div>
          </CarouselBox>
        </Carousel>

        <Dots quantity={quantity} active={active} />
        <Button
          color="blue"
          onClick={handleSetProximo}
          isVisible={active + 1 !== quantity}
        >
          Próximo
        </Button>
        <Button
          color="blue"
          onClick={handleStart}
          disabled={!acceptTerms}
          isVisible={active + 1 === quantity}
        >
          Começar
        </Button>

        {active > 0 && (
          <BtnVoltar type="button" onClick={handleSetAnterior}>
            &lt; Anterior
          </BtnVoltar>
        )}
      </Container>
    </>
  )
}

export default BemVindo
